import * as z from "zod";

/**
 * Admin-only opt-in toggle that wires up the support-v2 infrastructure
 * required for AI replies to inbound SMS on the merchant's Marketing /
 * Transactional phones (campaign and automation replies).
 *
 * Behavior:
 *   - Verifies the team already has `settings.support.enabled === true`. The
 *     admin must enable Support up front; this RPC will refuse to flip
 *     Support on under the hood so admins don't accidentally provision the
 *     support inbox without realizing it.
 *   - Flips `shopperAgent.enabled = true` (the gate at the marketing inbound
 *     edge) via `updateBaseSettings`, which also handles `activePeriods`
 *     bookkeeping.
 *   - Runs the shared `runShopperAgentEnableSideEffects` recipe (also
 *     invoked by the merchant-facing Commerce Agent onboarding RPC):
 *       - Enables `support.ai.enabled`, `support.ai.enabledPlatforms.sms`,
 *         plus other AI flags. Grants a 2-year Support AI trial banner
 *         bypass when the merchant is not already paying for Support AI.
 *       - Enables Marketing SMS billing (idempotent subsidy) so playbooks
 *         can send. Does not enable emailBilling or textsEnabled.
 *       - Enables the CRDB `default-send-ai-response-on-customer-reply` rule
 *         row and merges `sms` into its channels (other channels the merchant
 *         already replies on are preserved) so the support-v2 rule engine
 *         fires the AI agent on inbound SMS.
 *       - Sets `shopperAgent.replyConfig.enabled = true`.
 */
export const enableMarketingAiReplies = {
  name: "enableMarketingAiReplies" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ success: z.literal(true) }),
};
